import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES, ISSUE_TYPES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const buildIssueResultPayload = ({ issue, attempt, isBillable }) => {
  const issueResult = issue.issueResult || {};

  return {
    id: issueResult.id || createUUID(),
    issueId: issueResult.issueId || issue.id,
    attemptId: issueResult.attemptId || attempt?.id || attempt?.attemptId,
    type: issueResult.type || issue.type || ISSUE_TYPES.RECORDABLE,
    status: issueResult.status || issue.status,
    title: issueResult.title || issue.title || "",
    originalDescription:
      issueResult.originalDescription || issue.originalDescription || "",
    description: issueResult.description || issue.description || "",
    repairDescription: issueResult.repairDescription || issue.repairDescription,
    issueTemplateId: issueResult.issueTemplateId || issue.issueTemplateId,
    areaName: issueResult.areaName || issue.areaName,
    assignmentId:
      issueResult.assignmentId ||
      issue.assignmentId ||
      attempt?.assignmentId ||
      attempt?.assignment?.id,
    diagnosedIssue: issueResult.diagnosedIssue || issue.diagnosedIssue,
    submittedByUserId: issueResult.submittedByUserId || attempt?.userId,
    reviewDescription: issueResult.reviewDescription || issue.reviewDescription,
    incompleteReason: issueResult.incompleteReason ?? issue.incompleteReason,
    reviewedByDispatcher: issueResult.reviewedByDispatcher,
    verificationRequest: issueResult.verificationRequest,
    verificationResponse: issueResult.verificationResponse,
    isBillable,
  };
};

export const useIssueBillableViewModel = () => {
  const stateManager = useComponentState();
  const [issue, setIssue] = useState(null);

  const getIssue = ({ id }) =>
    stateManager.run(async () => {
      const response = await taskService.issues.getById({ id });

      if (response.status === HTTP_STATUSES.OK) {
        setIssue(response.data);
      }

      return response;
    });

  const updateBillable = ({ currentIssue, attempt, isBillable }) =>
    stateManager.run(async () => {
      const response = await taskService.issuesResults.upsertIssueResult({
        data: buildIssueResultPayload({
          issue: currentIssue,
          attempt,
          isBillable,
        }),
        toastMessageConfig: {
          success: {
            text: "Issue billable status updated successfully.",
          },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        setIssue((previousIssue) => ({
          ...previousIssue,
          isBillable,
          issueResult: response.data,
        }));
      }

      return response;
    });

  return {
    issue,
    isLoading: stateManager.isBusy(),
    getIssue,
    updateBillable,
  };
};
